import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AboutComponent } from './about/about.component';
import { HeaderNavigationComponent } from './header-navigation/header-navigation.component';
import { RgiScholarshipComponent } from './rgi-scholarship/rgi-scholarship.component';
import { EventsComponent } from './events/events.component';
import { CompetitionComponent } from './competition/competition.component';
import { GalleryComponent } from './gallery/gallery.component';
import { MediaComponent } from './media/media.component';
import { ClubComponent } from './club/club.component';
import { ResultComponent } from './result/result.component';
import { SportEventsComponent } from './sport-events/sport-events.component';
import { CulturalEventsComponent } from './cultural-events/cultural-events.component';
import { PhotogalleryComponent } from './photogallery/photogallery.component';
import { VideogalleryComponent } from './videogallery/videogallery.component';
import { RaagasUrvashiComponent } from './raagas-urvashi/raagas-urvashi.component';
import { EmployeeSportMeetComponent } from './employee-sport-meet/employee-sport-meet.component';
import { SummerCampComponent } from './summer-camp/summer-camp.component';
import { EmployeeSportsComponent } from './employee-sports/employee-sports.component';
import { KiteFestivalComponent } from './kite-festival/kite-festival.component';
import { ChessFestComponent } from './chess-fest/chess-fest.component';
import { ItoolovemynationComponent } from './itoolovemynation/itoolovemynation.component';
import { FidechessGalleryComponent } from './fidechess-gallery/fidechess-gallery.component';
import { KiteFestivalGalleryComponent } from './kite-festival-gallery/kite-festival-gallery.component';
import { SjanAwardGalleryComponent } from './sjan-award-gallery/sjan-award-gallery.component';
import { DhamaalDandiyaYearlyComponent } from './dhamaal-dandiya-yearly/dhamaal-dandiya-yearly.component';
import { ItoohavetalentComponent } from './itoohavetalent/itoohavetalent.component';
import { RapidChessTournamentComponent } from './rapid-chess-tournament/rapid-chess-tournament.component';
import { ChessCompetitionComponent } from './chess-competition/chess-competition.component';
import { DhamaalDandiyaYear2019Component } from './dhamaal-dandiya-year2019/dhamaal-dandiya-year2019.component';
import { ContactComponent } from './contact/contact.component';
import { DhamaalDandiyaYear2018Component } from './dhamaal-dandiya-year2018/dhamaal-dandiya-year2018.component';
import { DhamaalDandiyaYear2017Component } from './dhamaal-dandiya-year2017/dhamaal-dandiya-year2017.component';
import { DhamaalDandiyaYear2016Component } from './dhamaal-dandiya-year2016/dhamaal-dandiya-year2016.component';
import { DhamaalDandiyaYear2015Component } from './dhamaal-dandiya-year2015/dhamaal-dandiya-year2015.component';
import { PubgComponent } from './pubg/pubg.component';
import { RaisoniPremierLeagueComponent } from './raisoni-premier-league/raisoni-premier-league.component';
import { BadmintonSeriesComponent } from './badminton-series/badminton-series.component';
import { SjanAwardComponent } from './sjan-award/sjan-award.component';
import { NationalFederationComponent } from './national-federation/national-federation.component';
import { ClassicConclaveComponent } from './classic-conclave/classic-conclave.component';
import { LataMangeshkarComponent } from './lata-mangeshkar/lata-mangeshkar.component';
import { FideChesscompetitionComponent } from './fide-chesscompetition/fide-chesscompetition.component';
import { ArvindUpadhyeComponent } from './arvind-upadhye/arvind-upadhye.component';
import { KalyaniDeshpandeComponent } from './kalyani-deshpande/kalyani-deshpande.component';
import { HrishikeshKarmarkarComponent } from './hrishikesh-karmarkar/hrishikesh-karmarkar.component';
import { OnlineRahulJoshiComponent } from './online-rahul-joshi/online-rahul-joshi.component';
import { OnlineSadhanaShiledarComponent } from './online-sadhana-shiledar/online-sadhana-shiledar.component';
import { OnlineBhupaalPanshikarComponent } from './online-bhupaal-panshikar/online-bhupaal-panshikar.component';
import { VivekBansodComponent } from './vivek-bansod/vivek-bansod.component';
import { SwarRangComponent } from './swar-rang/swar-rang.component';
import { KonkanKanyaComponent } from './konkan-kanya/konkan-kanya.component';
import { GaneshaUtsavaComponent } from './ganesha-utsava/ganesha-utsava.component';
import { ShivajiMahotsavComponent } from './shivaji-mahotsav/shivaji-mahotsav.component';
import { DanceCityDanceComponent } from './dance-city-dance/dance-city-dance.component';
import { FlashMobComponent } from './flash-mob/flash-mob.component';
import { DhamaalDandiyaComponent } from './dhamaal-dandiya/dhamaal-dandiya.component';
import { FideChess2021Component } from './fide-chess2021/fide-chess2021.component';
import { FideChess2019Component } from './fide-chess2019/fide-chess2019.component';
import { FideChess2018Component } from './fide-chess2018/fide-chess2018.component';
import { DevakiPanditComponent } from './devaki-pandit/devaki-pandit.component';
import { AditiUpadhyaComponent } from './aditi-upadhya/aditi-upadhya.component';
import { PrasadKhapardeComponent } from './prasad-khaparde/prasad-khaparde.component';
import { ManjushaPatilComponent } from './manjusha-patil/manjusha-patil.component';
import { VidushiComponent } from './vidushi/vidushi.component';
import { UrvashiShahComponent } from './urvashi-shah/urvashi-shah.component';
import { BhupaalPanshikarComponent } from './bhupaal-panshikar/bhupaal-panshikar.component';
import { KakoliComponent } from './kakoli/kakoli.component';
import { PriyankaComponent } from './priyanka/priyanka.component';
import { ManbhavanComponent } from './manbhavan/manbhavan.component';
import { NiraliKartikComponent } from './nirali-kartik/nirali-kartik.component';
import { JugalbandiComponent } from './jugalbandi/jugalbandi.component';
import { RegisterSummerCampComponent } from './register-summer-camp/register-summer-camp.component';
import { AssociationComponent } from './association/association.component';
import { HttpClientModule } from '@angular/common/http';
import { RumiHaiComponent } from './rumi-hai/rumi-hai.component';
import { SawaniSathayeComponent } from './sawani-sathaye/sawani-sathaye.component';
import { KonkanKanyaRegistartionComponent } from './konkan-kanya-registartion/konkan-kanya-registartion.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { MelvinLouiseComponent } from './melvin-louise/melvin-louise.component';
import { RegisterMelvinLouiseComponent } from './register-melvin-louise/register-melvin-louise.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { MusicalCompComponent } from './musical-comp/musical-comp.component';
import { ShootsightCompComponent } from './shootsight-comp/shootsight-comp.component';
import { StepupComponent } from './stepup/stepup.component';
import { NaadNinaadComponent } from './naad-ninaad/naad-ninaad.component';
import { Itoohavetalent22Component } from './itoohavetalent22/itoohavetalent22.component';
import { EmployeeSportTwentyThreeComponent } from './employee-sport-twenty-three/employee-sport-twenty-three.component';
import { ModalPopupComponent } from './modal-popup/modal-popup.component';
import { HarshitaGautamComponent } from './harshita-gautam/harshita-gautam.component';
import { PgRedirectComponent } from './pg-redirect/pg-redirect.component';
import { PgResponseComponent } from './pg-response/pg-response.component';
import { ViewharshitaGautamComponent } from './viewharshita-gautam/viewharshita-gautam.component';
import { DressDesignComponent } from './dress-design/dress-design.component';
import { ChessTournament23Component } from './chess-tournament23/chess-tournament23.component';
import { RegisterLataMangeshkarWardhaComponent } from './register-lata-mangeshkar-wardha/register-lata-mangeshkar-wardha.component';
import { ChessTournamentBhandaraComponent } from './chess-tournament-bhandara/chess-tournament-bhandara.component';
import { NrutyavishkarComponent } from './nrutyavishkar/nrutyavishkar.component';
import { LataMageshkarWardhaEventComponent } from './lata-mageshkar-wardha-event/lata-mageshkar-wardha-event.component';
import { LataMageshkarChandrapurEventComponent } from './lata-mageshkar-chandrapur-event/lata-mageshkar-chandrapur-event.component';
import { MusicalRejuvenationComponent } from './musical-rejuvenation/musical-rejuvenation.component';
import { SanjeevAbhyankarNagpurComponent } from './sanjeev-abhyankar-nagpur/sanjeev-abhyankar-nagpur.component';
import { SanjeevAbhyankarAmravatiComponent } from './sanjeev-abhyankar-amravati/sanjeev-abhyankar-amravati.component';
import { LataMageshkarBhandaraEventComponent } from './lata-mageshkar-bhandara-event/lata-mageshkar-bhandara-event.component';
import { UnforgettableKkComponent } from './unforgettable-kk/unforgettable-kk.component';
import { SupportEncouragementComponent } from './support-encouragement/support-encouragement.component';
import { SlumSoccerComponent } from './slum-soccer/slum-soccer.component';
import { RegisterUnforgettableKkComponent } from './register-unforgettable-kk/register-unforgettable-kk.component';
import { FideChess2023Component } from './fide-chess2023/fide-chess2023.component';
import { ChessChampionship2023Component } from './chess-championship2023/chess-championship2023.component';
import { RegisterDanceEventComponent } from './register-dance-event/register-dance-event.component';
import { MemorialCupComponent } from './memorial-cup/memorial-cup.component';
import { RegisterClassicalVocalAmtComponent } from './register-classical-vocal-amt/register-classical-vocal-amt.component';
import { RegisterClassicalVocalNagpurComponent } from './register-classical-vocal-nagpur/register-classical-vocal-nagpur.component';
import { SiyavrRamComponent } from './siyavr-ram/siyavr-ram.component';
import { RegisterMemorialArcheryTournamentComponent } from './register-memorial-archery-tournament/register-memorial-archery-tournament.component';
import { LataMangeshkarAkolaEventComponent } from './lata-mangeshkar-akola-event/lata-mangeshkar-akola-event.component';
import { RegisterLataMangeshkarAkolaComponent } from './register-lata-mangeshkar-akola/register-lata-mangeshkar-akola.component';
import { LataMangeshkarYavatmalEventComponent } from './lata-mangeshkar-yavatmal-event/lata-mangeshkar-yavatmal-event.component';
import { RegisterLataMangeshkarYavatmalComponent } from './register-lata-mangeshkar-yavatmal/register-lata-mangeshkar-yavatmal.component';
import { NagpurDistrictUnderEllevenTournamentComponent } from './nagpur-district-under-elleven-tournament/nagpur-district-under-elleven-tournament.component';
import { TestimonialComponent } from './testimonial/testimonial.component';
import { BasketballChampionshipComponent } from './basketball-championship/basketball-championship.component';
import { RegisterLataMangeshkarChhindwaraComponent } from './register-lata-mangeshkar-chhindwara/register-lata-mangeshkar-chhindwara.component';
import { LataMangeshkarBetulEventComponent } from './lata-mangeshkar-betul-event/lata-mangeshkar-betul-event.component';
import { RegisterLataMangeshkarBetulComponent } from './register-lata-mangeshkar-betul/register-lata-mangeshkar-betul.component';
import { LataMangeshkarChhindwaraEventComponent } from './lata-mangeshkar-chhindwara-event/lata-mangeshkar-chhindwara-event.component';
import { BadmintonTournamentComponent } from './badminton-tournament/badminton-tournament.component';
import { FideRatingChess2023Component } from './fide-rating-chess2023/fide-rating-chess2023.component';
import { FideRatingChessTournamentComponent } from './fide-rating-chess-tournament/fide-rating-chess-tournament.component';
import { ArcheryTournamentNagpurComponent } from './archery-tournament-nagpur/archery-tournament-nagpur.component';
import { ArcheryTournamentAmravatiComponent } from './archery-tournament-amravati/archery-tournament-amravati.component';
import { ArcheryTournamentPuneComponent } from './archery-tournament-pune/archery-tournament-pune.component';
import { RegistrationAnkalikarComponent } from './registration-ankalikar/registration-ankalikar.component';
import { VidushiAartiAnkalikarComponent } from './vidushi-aarti-ankalikar/vidushi-aarti-ankalikar.component';
import { FutsalTournamentComponent } from './futsal-tournament/futsal-tournament.component';
import { TableTennisAmravatiComponent } from './table-tennis-amravati/table-tennis-amravati.component';
import { NationalFederationOfBlindComponent } from './national-federation-of-blind/national-federation-of-blind.component';
import { DhamaalDandiyaYear2023Component } from './dhamaal-dandiya-year2023/dhamaal-dandiya-year2023.component';
import { PuneInternationalChessTournamentComponent } from './pune-international-chess-tournament/pune-international-chess-tournament.component';
import { NeevEmployeeSportsMeetComponent } from './neev-employee-sports-meet/neev-employee-sports-meet.component';
import { SjanAwardTwentyfourComponent } from './sjan-award-twentyfour/sjan-award-twentyfour.component';
import { FootballTournamentComponent } from './football-tournament/football-tournament.component';
import { SwimmingCompetitionComponent } from './swimming-competition/swimming-competition.component';
import { ChessChampionshipComponent } from './chess-championship/chess-championship.component';
import { ArmsportCompetitionComponent } from './armsport-competition/armsport-competition.component';
import { FideChessAmtComponent } from './fide-chess-amt/fide-chess-amt.component';
import { SadabaiRaisoniWomensBatmintonComponent } from './sadabai-raisoni-womens-batminton/sadabai-raisoni-womens-batminton.component';
import { MendatoryDisclosureComponent } from './mendatory-disclosure/mendatory-disclosure.component';
import { SecondChessChampionshipComponent } from './second-chess-championship/second-chess-championship.component';
import { NagpurOpenGirlsChessComponent } from './nagpur-open-girls-chess/nagpur-open-girls-chess.component';
import { MemorialInternationalComponent } from './memorial-international/memorial-international.component';
import { SecondFadeRatingChessTournamentComponent } from './second-fade-rating-chess-tournament/second-fade-rating-chess-tournament.component';
import { BadmintonCompePuneComponent } from './badminton-compe-pune/badminton-compe-pune.component';
import { BadmintonCompetitionComponent } from './badminton-competition/badminton-competition.component';
import { SjanRaisoniAchieversAwardComponent } from './sjan-raisoni-achievers-award/sjan-raisoni-achievers-award.component';
import { BlitzChessChampionshipComponent } from './blitz-chess-championship/blitz-chess-championship.component';
import { BadmintonCompeVidarbhComponent } from './badminton-compe-vidarbh/badminton-compe-vidarbh.component';
import { KarandakAuditionsComponent } from './karandak-auditions/karandak-auditions.component';
import { KarandakAuditionsKolhapurComponent } from './karandak-auditions-kolhapur/karandak-auditions-kolhapur.component';
import { KarandakAuditionsRatnagiriComponent } from './karandak-auditions-ratnagiri/karandak-auditions-ratnagiri.component';
import { KarandakAuditionsPuneComponent } from './karandak-auditions-pune/karandak-auditions-pune.component';
import { PuneCheckmateChallengeComponent } from './pune-checkmate-challenge/pune-checkmate-challenge.component';
import { JhipruAndChimnayanoComponent } from './jhipru-and-chimnayano/jhipru-and-chimnayano.component';
import { YonexSunriseChandrapurComponent } from './yonex-sunrise-chandrapur/yonex-sunrise-chandrapur.component';
import { YonexSunriseVidarbhaLevalComponent } from './yonex-sunrise-vidarbha-leval/yonex-sunrise-vidarbha-leval.component';
import { CricketTournamentComponent } from './cricket-tournament/cricket-tournament.component';
import { SjanT20CricketTournamentComponent } from './sjan-t20-cricket-tournament/sjan-t20-cricket-tournament.component';
import { WomensChessComponent } from './womens-chess/womens-chess.component';
import { OpenAndGirlsSelectionChessComponent } from './open-and-girls-selection-chess/open-and-girls-selection-chess.component';
import { BadmintonChampionshipComponent } from './badminton-championship/badminton-championship.component';
import { BuldhanaDistrictBadmintonChampionshipComponent } from './buldhana-district-badminton-championship/buldhana-district-badminton-championship.component';
import { BhandaraOneDayRapidChessTournamentComponent } from './bhandara-one-day-rapid-chess-tournament/bhandara-one-day-rapid-chess-tournament.component';
import { InternationalFideRapidRatingChessTournamentComponent } from './international-fide-rapid-rating-chess-tournament/international-fide-rapid-rating-chess-tournament.component';
import { FideRapidRatingChessTournamentComponent } from './fide-rapid-rating-chess-tournament/fide-rapid-rating-chess-tournament.component';
import { MhWomensBadmintonTournamentComponent } from './mh-womens-badminton-tournament/mh-womens-badminton-tournament.component';
import { MemorialChessTournamentGondiaComponent } from './memorial-chess-tournament-gondia/memorial-chess-tournament-gondia.component';
import { ExtendedSupportComponent } from './extended-support/extended-support.component';
import { ChessChampionshipUnderSevenSeventeenComponent } from './chess-championship-under-seven-seventeen/chess-championship-under-seven-seventeen.component';
import { ChessChampionshipUnderNineNineteenComponent } from './chess-championship-under-nine-nineteen/chess-championship-under-nine-nineteen.component';
import { ChessChampionshipUnderElevenFifteenComponent } from './chess-championship-under-eleven-fifteen/chess-championship-under-eleven-fifteen.component';
import { RaisoniMemorialVidarbhaLevelBadmintonTournamentComponent } from './raisoni-memorial-vidarbha-level-badminton-tournament/raisoni-memorial-vidarbha-level-badminton-tournament.component';
import { NagpurDistrictAmateurBadmintonTournamentComponent } from './nagpur-district-amateur-badminton-tournament/nagpur-district-amateur-badminton-tournament.component';
import { BuldhanaDistrictBadmintonChampionshipTwentyFiveComponent } from './buldhana-district-badminton-championship-twenty-five/buldhana-district-badminton-championship-twenty-five.component';
import { ChessTournamentTwentyFiveComponent } from './chess-tournament-twenty-five/chess-tournament-twenty-five.component';
import { PalgharBadmintonTournamentComponent } from './palghar-badminton-tournament/palghar-badminton-tournament.component';
import { GadchiroliDistrictBadmintonChampionshipComponent } from './gadchiroli-district-badminton-championship/gadchiroli-district-badminton-championship.component';
import { MemorialChessTournamentRatnagiriComponent } from './memorial-chess-tournament-ratnagiri/memorial-chess-tournament-ratnagiri.component';
import { NagpurDistrictFirstSelectionBadmintonTournamentComponent } from './nagpur-district-first-selection-badminton-tournament/nagpur-district-first-selection-badminton-tournament.component';
import { DhuleDistBadmintonChampionshipComponent } from './dhule-dist-badminton-championship/dhule-dist-badminton-championship.component';
import { NandedDistrictChessSelectionTournamentComponent } from './nanded-district-chess-selection-tournament/nanded-district-chess-selection-tournament.component';
import { PuneDistBadmintonChampionshipComponent } from './pune-dist-badminton-championship/pune-dist-badminton-championship.component';
import { NeevTwentyFiveComponent } from './neev-twenty-five/neev-twenty-five.component';
import { TelanganaStateSeniorBadChamComponent } from './telangana-state-senior-bad-cham/telangana-state-senior-bad-cham.component';
import { ChessCompetitionPrizeDistrubutionComponent } from './chess-competition-prize-distrubution/chess-competition-prize-distrubution.component';
import { WrestlingChampionshipsTwentyFiveComponent } from './wrestling-championships-twenty-five/wrestling-championships-twenty-five.component';
import { SwaraginiComponent } from './swaragini/swaragini.component';
import { GhraisoniMemorialAmravatiDistrictBadmintonChampionshipTwentyfiveComponent } from './ghraisoni-memorial-amravati-district-badminton-championship-twentyfive/ghraisoni-memorial-amravati-district-badminton-championship-twentyfive.component';
import { AmravatiDistrictBadmintonComponent } from './amravati-district-badminton/amravati-district-badminton.component';
import { GhrMemorialPuneFideRapidRatingChessTwentyfiveComponent } from './ghr-memorial-pune-fide-rapid-rating-chess-twentyfive/ghr-memorial-pune-fide-rapid-rating-chess-twentyfive.component';
import { ChessAssociationNgpCelebratesInternationalChessDayComponent } from './chess-association-ngp-celebrates-international-chess-day/chess-association-ngp-celebrates-international-chess-day.component';
import { EkShamGeetoKeNaamComponent } from './ek-sham-geeto-ke-naam/ek-sham-geeto-ke-naam.component';
import { NagpurBelowSeventeenHundredFideRatingChessTournamentComponent } from './nagpur-below-seventeen-hundred-fide-rating-chess-tournament/nagpur-below-seventeen-hundred-fide-rating-chess-tournament.component';
import { NandedDistrictBadmintonChampionshipComponent } from './nanded-district-badminton-championship/nanded-district-badminton-championship.component';
import { GhRaisoniBadmintonUnderFifteenUnderSeventeenComponent } from './gh-raisoni-badminton-under-fifteen-under-seventeen/gh-raisoni-badminton-under-fifteen-under-seventeen.component';
import { DivisionLevelChessMeetComponent } from './division-level-chess-meet/division-level-chess-meet.component';
import { PithoraOneDayRapidChessTournamentComponent } from './pithora-one-day-rapid-chess-tournament/pithora-one-day-rapid-chess-tournament.component';
import { SargujaDivisionOneDayRapidChessTournamentComponent } from './sarguja-division-one-day-rapid-chess-tournament/sarguja-division-one-day-rapid-chess-tournament.component';
import { ThaneFideRapidChessTournamentComponent } from './thane-fide-rapid-chess-tournament/thane-fide-rapid-chess-tournament.component';
import { RapidChessTournamentConcludesComponent } from './rapid-chess-tournament-concludes/rapid-chess-tournament-concludes.component';
import { MarathwadaOpenBadmintonTournamentComponent } from './marathwada-open-badminton-tournament/marathwada-open-badminton-tournament.component';
import { RaigadDistrictLevelOneDayComponent } from './raigad-district-level-one-day/raigad-district-level-one-day.component';
import { JalnaRapidChessTournamentComponent } from './jalna-rapid-chess-tournament/jalna-rapid-chess-tournament.component';
import { NagpurChessFestivalComponent } from './nagpur-chess-festival/nagpur-chess-festival.component';
import { NeevTwentySixComponent } from './neev-twenty-six/neev-twenty-six.component';
import { AboutFoundationComponent } from './about-foundation/about-foundation.component';
import { AdvisoryBoardComponent } from './advisory-board/advisory-board.component';
import { AboutTeamComponent } from './about-team/about-team.component';
import { MissionVissionComponent } from './mission-vission/mission-vission.component';
import { ZankarLavaniComponent } from './zankar-lavani/zankar-lavani.component';
import { ChessOpenTournamentComponent } from './chess-open-tournament/chess-open-tournament.component';
import { JalnaChessTournamentComponent } from './jalna-chess-tournament/jalna-chess-tournament.component';
import { TwentyEigthNationalsChessChampionshipComponent } from './twenty-eigth-nationals-chess-championship/twenty-eigth-nationals-chess-championship.component';
import { JalnaOpenChessTournamentComponent } from './jalna-open-chess-tournament/jalna-open-chess-tournament.component';
import { NagpurDistrictChessTournamentComponent } from './nagpur-district-chess-tournament/nagpur-district-chess-tournament.component';
import { NagpurDistrictRapidBlitzChessComponent } from './nagpur-district-rapid-blitz-chess/nagpur-district-rapid-blitz-chess.component';
import { SingrauliDistrictChessTournamentComponent } from './singrauli-district-chess-tournament/singrauli-district-chess-tournament.component';
import { RatlamOpenRapidChessTournamentComponent } from './ratlam-open-rapid-chess-tournament/ratlam-open-rapid-chess-tournament.component';
import { BhandaraRapidChessComponent } from './bhandara-rapid-chess/bhandara-rapid-chess.component';
import { KhairagarhChessTournamentComponent } from './khairagarh-chess-tournament/khairagarh-chess-tournament.component';
import { PuneChessTournamentComponent } from './pune-chess-tournament/pune-chess-tournament.component';
import { GwaliorOneDayChessTournamentComponent } from './gwalior-one-day-chess-tournament/gwalior-one-day-chess-tournament.component';
import { ChessTournamentChandrapurComponent } from './chess-tournament-chandrapur/chess-tournament-chandrapur.component';
import { SambhajinagarChessTournamentComponent } from './sambhajinagar-chess-tournament/sambhajinagar-chess-tournament.component';
import { DurgDivisionalChessTournamentComponent } from './durg-divisional-chess-tournament/durg-divisional-chess-tournament.component';
import { SurajpurChessTournamentComponent } from './surajpur-chess-tournament/surajpur-chess-tournament.component';
import { AmbikapurChessTournamentComponent } from './ambikapur-chess-tournament/ambikapur-chess-tournament.component';
import { KatniFideChessTournamentComponent } from './katni-fide-chess-tournament/katni-fide-chess-tournament.component';
import { GhraisoniChessFestivalComponent } from './ghraisoni-chess-festival/ghraisoni-chess-festival.component';
import { KhargoneBadmintonComponent } from './khargone-badminton/khargone-badminton.component';
import { InternationalFideRapidRatingChessTournamentPuneComponent } from './international-fide-rapid-rating-chess-tournament-pune/international-fide-rapid-rating-chess-tournament-pune.component';
import { NandurbarChessTournamentComponent } from './nandurbar-chess-tournament/nandurbar-chess-tournament.component';
import { MaharashtraStateSubJuniorComponent } from './maharashtra-state-sub-junior/maharashtra-state-sub-junior.component';
import { YavatmalDistrictBadmintonComponent } from './yavatmal-district-badminton/yavatmal-district-badminton.component';
import { YonexNagpurDistrictComponent } from './yonex-nagpur-district/yonex-nagpur-district.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    HeaderNavigationComponent,
    RgiScholarshipComponent,
    EventsComponent,
    CompetitionComponent,
    GalleryComponent,
    MediaComponent,
    ClubComponent,
    ResultComponent,
    SportEventsComponent,
    CulturalEventsComponent,
    PhotogalleryComponent,
    VideogalleryComponent,
    RaagasUrvashiComponent,
    EmployeeSportMeetComponent,
    SummerCampComponent,
    EmployeeSportsComponent,
    KiteFestivalComponent,
    ChessFestComponent,
    ItoolovemynationComponent,
    FidechessGalleryComponent,
    KiteFestivalGalleryComponent,
    SjanAwardGalleryComponent,
    DhamaalDandiyaYearlyComponent,
    ItoohavetalentComponent,
    DhamaalDandiyaYear2019Component,
    ContactComponent,
    RapidChessTournamentComponent,
    ChessCompetitionComponent,
    DhamaalDandiyaYear2019Component,
    DhamaalDandiyaYear2018Component,
    DhamaalDandiyaYear2017Component,
    DhamaalDandiyaYear2016Component,
    DhamaalDandiyaYear2015Component,
    PubgComponent,
    RaisoniPremierLeagueComponent,
    BadmintonSeriesComponent,
    SjanAwardComponent,
    NationalFederationComponent,
    ClassicConclaveComponent,
    LataMangeshkarComponent,
    FideChesscompetitionComponent,
    ArvindUpadhyeComponent,
    KalyaniDeshpandeComponent,
    HrishikeshKarmarkarComponent,
    OnlineRahulJoshiComponent,
    OnlineSadhanaShiledarComponent,
    OnlineBhupaalPanshikarComponent,
    VivekBansodComponent,
    SwarRangComponent,
    KonkanKanyaComponent,
    GaneshaUtsavaComponent,
    ShivajiMahotsavComponent,
    DanceCityDanceComponent,
    FlashMobComponent,
    DhamaalDandiyaComponent,
    FideChess2021Component,
    FideChess2019Component,
    FideChess2018Component,
    DevakiPanditComponent,
    AditiUpadhyaComponent,
    PrasadKhapardeComponent,
    ManjushaPatilComponent,
    VidushiComponent,
    UrvashiShahComponent,
    BhupaalPanshikarComponent,
    KakoliComponent,
    PriyankaComponent,
    ManbhavanComponent,
    NiraliKartikComponent,
    JugalbandiComponent,
    RegisterSummerCampComponent,
    AssociationComponent,
    RumiHaiComponent,
    SawaniSathayeComponent,
    KonkanKanyaRegistartionComponent,
    MelvinLouiseComponent,
    RegisterMelvinLouiseComponent,
    PaymentFormComponent,
    ThankYouComponent,
    MusicalCompComponent,
    ShootsightCompComponent,
    StepupComponent,
    NaadNinaadComponent,
    Itoohavetalent22Component,
    EmployeeSportTwentyThreeComponent,
    ModalPopupComponent,
    HarshitaGautamComponent,
    PgRedirectComponent,
    PgResponseComponent,
    ViewharshitaGautamComponent,
    DressDesignComponent,
    ChessTournament23Component,
    RegisterLataMangeshkarWardhaComponent,
    ChessTournamentBhandaraComponent,
    NrutyavishkarComponent,
    LataMageshkarWardhaEventComponent,
    LataMageshkarChandrapurEventComponent,
    MusicalRejuvenationComponent,
    SanjeevAbhyankarNagpurComponent,
    SanjeevAbhyankarAmravatiComponent,
    LataMageshkarBhandaraEventComponent,
    UnforgettableKkComponent,
    SupportEncouragementComponent,
    SlumSoccerComponent,
    RegisterUnforgettableKkComponent,
    FideChess2023Component,
    ChessChampionship2023Component,
    RegisterDanceEventComponent,
    MemorialCupComponent,
    RegisterClassicalVocalAmtComponent,
    RegisterClassicalVocalNagpurComponent,
    SiyavrRamComponent,
    RegisterMemorialArcheryTournamentComponent,
    LataMangeshkarAkolaEventComponent,
    RegisterLataMangeshkarAkolaComponent,
    LataMangeshkarYavatmalEventComponent,
    RegisterLataMangeshkarYavatmalComponent,
    NagpurDistrictUnderEllevenTournamentComponent,
    TestimonialComponent,
    BasketballChampionshipComponent,
    RegisterLataMangeshkarChhindwaraComponent,
    LataMangeshkarBetulEventComponent,
    RegisterLataMangeshkarBetulComponent,
    LataMangeshkarChhindwaraEventComponent,
    BadmintonTournamentComponent,
    FideRatingChess2023Component,
    FideRatingChessTournamentComponent,
    ArcheryTournamentNagpurComponent,
    ArcheryTournamentAmravatiComponent,
    ArcheryTournamentPuneComponent,
    RegistrationAnkalikarComponent,
    VidushiAartiAnkalikarComponent,
    FutsalTournamentComponent,
    TableTennisAmravatiComponent,
    NationalFederationOfBlindComponent,
    DhamaalDandiyaYear2023Component,
    PuneInternationalChessTournamentComponent,
    NeevEmployeeSportsMeetComponent,
    SjanAwardTwentyfourComponent,
    FootballTournamentComponent,
    SwimmingCompetitionComponent,
    ChessChampionshipComponent,
    ArmsportCompetitionComponent,
    FideChessAmtComponent,
    SadabaiRaisoniWomensBatmintonComponent,
    MendatoryDisclosureComponent,
    SecondChessChampionshipComponent,
    NagpurOpenGirlsChessComponent,
    MemorialInternationalComponent,
    SecondFadeRatingChessTournamentComponent,
    BadmintonCompePuneComponent,
    BadmintonCompetitionComponent,
    SjanRaisoniAchieversAwardComponent,
    BlitzChessChampionshipComponent,
    BadmintonCompeVidarbhComponent,
    KarandakAuditionsComponent,
    KarandakAuditionsKolhapurComponent,
    KarandakAuditionsRatnagiriComponent,
    KarandakAuditionsPuneComponent,
    PuneCheckmateChallengeComponent,
    JhipruAndChimnayanoComponent,
    YonexSunriseChandrapurComponent,
    YonexSunriseVidarbhaLevalComponent,
    CricketTournamentComponent,
    SjanT20CricketTournamentComponent,
    WomensChessComponent,
    OpenAndGirlsSelectionChessComponent,
    BadmintonChampionshipComponent,
    BuldhanaDistrictBadmintonChampionshipComponent,
    BhandaraOneDayRapidChessTournamentComponent,
    InternationalFideRapidRatingChessTournamentComponent,
    FideRapidRatingChessTournamentComponent,
    MhWomensBadmintonTournamentComponent,
    MemorialChessTournamentGondiaComponent,
    ExtendedSupportComponent,
    ChessChampionshipUnderSevenSeventeenComponent,
    ChessChampionshipUnderNineNineteenComponent,
    ChessChampionshipUnderElevenFifteenComponent,
    RaisoniMemorialVidarbhaLevelBadmintonTournamentComponent,
    NagpurDistrictAmateurBadmintonTournamentComponent,
    BuldhanaDistrictBadmintonChampionshipTwentyFiveComponent,
    ChessTournamentTwentyFiveComponent,
    PalgharBadmintonTournamentComponent,
    GadchiroliDistrictBadmintonChampionshipComponent,
    MemorialChessTournamentRatnagiriComponent,
    NagpurDistrictFirstSelectionBadmintonTournamentComponent,
    DhuleDistBadmintonChampionshipComponent,
    NandedDistrictChessSelectionTournamentComponent,
    PuneDistBadmintonChampionshipComponent,
    NeevTwentyFiveComponent,
    TelanganaStateSeniorBadChamComponent,
    ChessCompetitionPrizeDistrubutionComponent,
    WrestlingChampionshipsTwentyFiveComponent,
    SwaraginiComponent,
    GhraisoniMemorialAmravatiDistrictBadmintonChampionshipTwentyfiveComponent,
    AmravatiDistrictBadmintonComponent,
    GhrMemorialPuneFideRapidRatingChessTwentyfiveComponent,
    ChessAssociationNgpCelebratesInternationalChessDayComponent,
    EkShamGeetoKeNaamComponent,
    NagpurBelowSeventeenHundredFideRatingChessTournamentComponent,
    NandedDistrictBadmintonChampionshipComponent,
    GhRaisoniBadmintonUnderFifteenUnderSeventeenComponent,
    DivisionLevelChessMeetComponent,
    PithoraOneDayRapidChessTournamentComponent,
    SargujaDivisionOneDayRapidChessTournamentComponent,
    ThaneFideRapidChessTournamentComponent,
    RapidChessTournamentConcludesComponent,
    MarathwadaOpenBadmintonTournamentComponent,
    RaigadDistrictLevelOneDayComponent,
    JalnaRapidChessTournamentComponent,
    NagpurChessFestivalComponent,
    NeevTwentySixComponent,
    AboutFoundationComponent,
    AdvisoryBoardComponent,
    AboutTeamComponent,
    MissionVissionComponent,
    ZankarLavaniComponent,
    ChessOpenTournamentComponent,
    JalnaChessTournamentComponent,
    TwentyEigthNationalsChessChampionshipComponent,
    JalnaOpenChessTournamentComponent,
    NagpurDistrictChessTournamentComponent,
    NagpurDistrictRapidBlitzChessComponent,
    SingrauliDistrictChessTournamentComponent,
    RatlamOpenRapidChessTournamentComponent,
    BhandaraRapidChessComponent,
    KhairagarhChessTournamentComponent,
    PuneChessTournamentComponent,
    GwaliorOneDayChessTournamentComponent,
    ChessTournamentChandrapurComponent,
    SambhajinagarChessTournamentComponent,
    DurgDivisionalChessTournamentComponent,
    SurajpurChessTournamentComponent,
    AmbikapurChessTournamentComponent,
    KatniFideChessTournamentComponent,
    GhraisoniChessFestivalComponent,
    KhargoneBadmintonComponent,
    InternationalFideRapidRatingChessTournamentPuneComponent,
    NandurbarChessTournamentComponent,
    MaharashtraStateSubJuniorComponent,
    YavatmalDistrictBadmintonComponent,
    YonexNagpurDistrictComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
